import React, { Fragment } from "react";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { fieldExistsOnPlayType } from "games/utils";

const PlayRadioGroupInput = ({
  inputName,
  label,
  play,
  handleInputChange,
  options,
  row,
  classes
}) => {
  return (
    <Fragment>
      {fieldExistsOnPlayType(play.playType, inputName) && (
        <div className={classes.input}>
          <FormLabel component="legend">{label}</FormLabel>
          <RadioGroup
            aria-label={inputName}
            value={play[inputName] || ""}
            onChange={(event) => handleInputChange(event, inputName)}
            row={row}
          >
            {options.map((option) => {
              return (
                <FormControlLabel
                  key={option.id}
                  value={option.id || null}
                  control={<Radio />}
                  label={option.name}
                />
              );
            })}
          </RadioGroup>
        </div>
      )}
    </Fragment>
  );
};

export default PlayRadioGroupInput;
